import {LoadingContent} from "../components/LoadingContent";
import useApiCall from "../hooks/CancellableApiCall";
import useUser from "../hooks/useUser";
import {Box, Button, Pagination, Paper, Checkbox, FormControlLabel} from "@mui/material";
import React, {useState} from "react";
import {HelpdeskTicketTable} from "../components/helpdesk/HelpdeskTicketTable";
import {Link as RouterLink, useSearchParams} from "react-router-dom";
import {HelpdeskPageninatedResponse} from "../data/helpdesk/HelpdeskPageninatedResponse";

export const ArchivedHelpdeskTicketsPage = () => {
    const [searchParams, setSearchParams] = useSearchParams()
    const page = parseInt(searchParams.get("page") ?? "1")
    const [ownTickets, setOwnTickets] = useState(false)
    const ticketData = useApiCall<HelpdeskPageninatedResponse>({
        url: ownTickets ? `/api/helpdesk/archived/-/?page=${page}` : `/api/helpdesk/archived/?page=${page}`
    })

    const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
        searchParams.set("page", value.toString())
        setSearchParams(searchParams)
    }

    const totalPages = ticketData.data?.pages ?? 1

    const userData = useUser()

    return <LoadingContent isLoading={userData.isLoading || ticketData.isLoading}>
        <Paper variant={"outlined"} style={{
            padding: "16px",
            overflowX: "auto"
        }}>
            <HelpdeskTicketTable ticketData={ticketData.data ?? {tickets: [], totalTickets: 0, pages: 1}}/>
            <Button component={RouterLink} to={`/helpdesk`} color="info">View Open Tickets</Button>
            <FormControlLabel sx={{float: "right", mr: 5}}
                control={<Checkbox checked={ownTickets} onChange={(_, checked) => setOwnTickets(checked)}/>}
                label={"Show own Tickets only"}/>
        </Paper>
        <Box sx={{justifyContent: "center", display: "flex", mt: 2, width: "100%"}}>
            <Pagination color={'secondary'} count={totalPages} page={page} style={{padding: 8}}
                        onChange={handleChange}/>
        </Box>
    </LoadingContent>
}